import { Component, Input, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { TextListInputService } from '../../services/text-list-input.service';

@Component({
  selector: 'app-text-list-input',
  templateUrl: './text-list-input.component.html',
  styleUrls: ['./text-list-input.component.scss']
})
export class TextListInputComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() maxLength: number;
  @Input() mandatory: boolean;
  @Input() helpTooltipText: string;
  @Input() inputMask: string;
  @Input() possibleValues: string[];
  @Input() isLoading: boolean;
  @Input() isDisabled: boolean;
  public value: string;

  get isInvalid() {
    return this.controlDirective && this.controlDirective.control.dirty && !this.controlDirective.control.valid;
  }

  constructor(@Self() public controlDirective: NgControl, private textListInputService: TextListInputService) {
    controlDirective.valueAccessor = this;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: any = () => {};

  public writeValue(value: string) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public handleInput() {
    this.onChange(this.value);

    this.textListInputService.setSelectedListValue(this.id, null);
  }

  public handleListItemClick(value: string) {
    this.value = value;

    this.textListInputService.setSelectedListValue(this.id, this.value);

    this.onChange(this.value);

    this.textListInputService.emitClearPossibleValues(this.id);
  }
}
